import React from 'react';
import { Box } from '@chakra-ui/react';
import { PrintEE } from './printEE';

export const PrintSubstate = ({
  education,
  experience,
  adresses,
  trips,
  relatives,
  ...rest
}) => {
  return (
    <Box>
      {Object.keys(rest).map((key, i) => (
        <Box pb={4} key={String(i)}>
          <strong>{`${key}:`}</strong>
          {` ${
            typeof rest[key] === 'object'
              ? JSON.stringify(rest[key], null, 2)
              : rest[key]
          }`}
        </Box>
      ))}
      <PrintEE {...{ education, experience, adresses, trips, relatives }} />
    </Box>
  );
};
